import React from 'react';
import { consultants } from '../../data/consultants';
import { ConsultantCard } from '../consultants/ConsultantCard';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeConsultants() {
  return <section className="bg-porcelain py-24 lg:py-32" data-id="element-204" data-mp="337otkygz8pfy">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-205" data-mp="37bwk916zwfgt">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-206" data-mp="3v0xjpyxuog9y">
          <SectionHeading label="Meet our consultants" title="The people behind every search" intro="Speak directly with one of our Executive Search Consultants about a leadership appointment or your next opportunity." data-id="element-207" data-mp="3ue9akvxesc6" />
          <ButtonLink to="/consultants" variant="outline" arrow className="self-start lg:self-auto" data-id="element-208" data-mp="3qx9c5g97xkop">
            All consultants
          </ButtonLink>
        </div>
        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-209" data-mp="2fk7459l6q3g5">
          {consultants.map(c => <ConsultantCard key={c.slug} consultant={c} data-id="element-210" data-mp="3ufgb8ydgqsz4" />)}
        </div>
      </div>
    </section>;
}